import { timeline } from "@/mocks/home";
import Reveal from "./Reveal";

export default function Timeline() {
  return (
    <section
      id="timeline"
      className="section-anchor relative overflow-hidden bg-background-950 py-14 text-background-100 md:py-20"
    >
      <div className="container-gua relative">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-400">
              <i className="ri-time-line"></i>
              时间线梳理
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-4xl">
              按时间线，看清每一个关键节点
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-300">
              与其道听途说，不如顺着时间脉络把来龙去脉一次理清。历史记录按序归档，随时回看。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,260px)_1fr] lg:gap-14">
          {/* period index */}
          <div className="hidden lg:block">
            <div className="sticky top-24 flex flex-col gap-3">
              <p className="text-xs font-semibold uppercase tracking-widest text-background-400">
                事件阶段
              </p>
              {timeline.map((p, i) => (
                <a
                  key={p.period}
                  href={`#period-${i}`}
                  className="rounded-lg border border-background-200/10 bg-background-900/40 px-4 py-3 text-sm font-medium text-background-200 transition hover:border-accent-400/40 hover:text-accent-300"
                >
                  {p.period}
                </a>
              ))}
            </div>
          </div>

          {/* timeline rail */}
          <div className="relative pl-6 md:pl-8">
            <span className="absolute left-0 top-1 h-full w-px bg-background-200/15 md:left-2"></span>

            {timeline.map((group, gi) => (
              <div key={group.period} id={`period-${gi}`} className="section-anchor mb-10 last:mb-0">
                <h3 className="mb-6 font-heading text-xl font-bold text-accent-300 md:text-2xl">
                  {group.period}
                </h3>
                <div className="space-y-5">
                  {group.events.map((ev) => (
                    <Reveal key={ev.date + ev.title}>
                      <article className="relative rounded-lg border border-background-200/10 bg-background-900/50 p-5 transition hover:border-accent-400/30">
                        <span className="absolute -left-6 top-6 flex h-4 w-4 items-center justify-center md:-left-8">
                          <span className="gua-dot h-3 w-3 rounded-full bg-primary-500"></span>
                        </span>
                        <div className="flex flex-wrap items-center gap-3">
                          <span className="font-heading text-sm font-bold text-background-50">
                            {ev.date}
                          </span>
                          <span className="rounded-md bg-accent-500/20 px-2 py-0.5 text-xs font-semibold text-accent-300">
                            {ev.tag}
                          </span>
                        </div>
                        <h4 className="mt-2 font-heading text-base font-bold text-background-50 md:text-lg">
                          {ev.title}
                        </h4>
                        <p className="mt-2 text-sm leading-relaxed text-background-300">{ev.desc}</p>
                      </article>
                    </Reveal>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}